import { render, staticRenderFns } from "./FlashInfoSubSection.vue?vue&type=template&id=964d0026&scoped=true&"
import script from "./FlashInfoSubSection.vue?vue&type=script&lang=js&"
export * from "./FlashInfoSubSection.vue?vue&type=script&lang=js&"
import style0 from "./FlashInfoSubSection.vue?vue&type=style&index=0&id=964d0026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964d0026",
  null
  
)

export default component.exports